// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"23fc92b5","553":"3f012651"}[chunkId] + ".chunk.css";
};